/* WEIRDEST — the masonry feed, the closeup panel and the save affordance.
 *
 * Extracted from sections/wc-discover.liquid on 2026-08-25. It was 28KB of inline script shipped on every
 * view of that page — parsed fresh each time, never cached, and counted against the HTML.
 *
 * Safe to move because it publishes NO globals and nothing else in the theme reaches into it.
 * Loaded with `defer`, which runs after the document is parsed and before DOMContentLoaded —
 * the same moment an end-of-body inline block ran, so every getElementById in here still finds
 * its element.
 */
(function () {
  document.documentElement.className += ' wcjs';
  var feed = document.getElementById('dv-feed');
  var cu = document.getElementById('dv-cu');
  if (!feed || !cu) return;
  var status = document.getElementById('dv-status');

  /* IDX: handle -> { k: the rhymes, w: the design family and its chips }. FACT: handle -> the
     live product facts. Filled one design at a time, on demand, from /products/<h>?view=kin.
     The wall ships no index at all: a closeup paints instantly from the tile that was clicked
     and the rhymes arrive from one ~1.3KB (gzipped) request that hover has usually made. */
  var IDX = {}, FACT = {}, PEND = {};

  function factsFromTile(el) {
    var p = el.getAttribute('data-p');
    return { t: el.getAttribute('data-t'), u: el.getAttribute('data-u'),
             p: p, av: el.getAttribute('data-av') !== '0',
             big: el.getAttribute('data-big'), full: !!p };
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  /* ------------------------------------------------------------------ saved spikes
     THE CORNER CONTROL IS THE GENRE'S SAVE, AND IT IS REAL: localStorage, this device only.
     No accounts, no counts, nothing invented. Stored facts are title/url/art — NO PRICE,
     because a stored price goes stale and every price this page prints is rendered live. */
  var KEY = 'wc-keeps';
  function keepsAll() { try { var j = JSON.parse(localStorage.getItem(KEY)); return j && typeof j === 'object' ? j : {}; } catch (e) { return {}; } }
  function keepsWrite(k) { try { localStorage.setItem(KEY, JSON.stringify(k)); } catch (e) {} }
  function keptCount() { var k = keepsAll(), n = 0, h; for (h in k) n++; return n; }
  function markKept(root) {
    var k = keepsAll(), bs = (root || document).querySelectorAll('[data-keep]');
    for (var i = 0; i < bs.length; i++) {
      var on = !!k[bs[i].getAttribute('data-keep')];
      bs[i].classList.toggle('on', on);
      bs[i].textContent = on ? 'Saved' : 'Save';
      bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function keptRows() {
    var n = keptCount(), rows = document.querySelectorAll('[data-keptview]'), i;
    for (i = 0; i < rows.length; i++) {
      rows[i].hidden = n === 0;
      var lab = rows[i].querySelector('[data-keptn]');
      if (lab) lab.textContent = n;
    }
  }
  function paintCuSave() {
    if (!current) return;
    var on = !!keepsAll()[current], bs = cu.querySelectorAll('[data-keepcu]');
    for (var i = 0; i < bs.length; i++) {
      bs[i].classList.toggle('on', on);
      bs[i].textContent = on ? 'Saved' : 'Save';
      bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function toggleKeep(h) {
    if (!h) return;
    var k = keepsAll();
    if (k[h]) { delete k[h]; }
    else {
      var f = FACT[h] || {};
      var tile = document.querySelector('.dv-spike[data-h="' + h.replace(/["\\]/g, '') + '"]');
      k[h] = { t: f.t || (tile ? tile.getAttribute('data-t') : '') || '',
               u: f.u || ('/products/' + encodeURIComponent(h)),
               i: f.big || (tile ? tile.getAttribute('data-big') : '') || '',
               at: Date.now() };
    }
    keepsWrite(k);
    markKept(document);
    paintCuSave();
    keptRows();
    if (status) status.textContent = k[h] ? 'Saved on this device.' : 'Removed from your saved spikes.';
  }

  var keptWrap = document.getElementById('dv-kept');
  var keptGrid = document.getElementById('dv-keptgrid');
  var feedSec = document.getElementById('dv-feedsec');
  function keptOpen() { return !!(keptWrap && !keptWrap.hidden); }
  function showKept() {
    if (!keptWrap || !keptGrid || !feedSec) return;
    var k = keepsAll(), hs = Object.keys(k).sort(function (a, b) { return (k[b].at || 0) - (k[a].at || 0); });
    var out = '';
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i], it = k[h];
      out += '<article class="dv-spike" data-h="' + esc(h) + '" data-t="' + esc(it.t) + '"' +
             ' data-u="' + esc(it.u) + '" data-big="' + esc(it.i) + '">' +
               '<div class="dv-art"><a href="' + esc(it.u) + '" tabindex="-1" aria-hidden="true">' +
                 (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy" decoding="async">' : '') +
               '</a><div class="dv-ov">' +
                 '<button class="kp on" type="button" data-keep="' + esc(h) + '" aria-pressed="true">Saved</button>' +
                 '<span class="dv-ovr"><a class="ovc" href="' + esc(it.u) + '" aria-label="Go straight to the item">' +
                   '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.6 3.2h4.2c.9 0 1.6.7 1.6 1.6v4.2a1.6 1.6 0 1 1-3.2 0V8.6l-7.1 7.1a1.7 1.7 0 0 1-2.4-2.4l7.1-7.1h-.2a1.6 1.6 0 1 1 0-3.2Z"/><path d="M4.6 7.4c0-1.5 1.2-2.7 2.7-2.7h3a1.5 1.5 0 0 1 0 3H7.6v9.9h9.9v-2.7a1.5 1.5 0 0 1 3 0v3c0 1.5-1.2 2.7-2.7 2.7H7.3a2.7 2.7 0 0 1-2.7-2.7Z"/></svg>' +
                 '</a></span>' +
               '</div></div>' +
               '<div class="dv-meta"><a class="dv-t" href="' + esc(it.u) + '">' + esc(it.t) + '</a></div>' +
             '</article>';
    }
    keptGrid.innerHTML = out || '<p class="dv-none">Nothing saved yet — hover a spike and press Save.</p>';
    keptWrap.hidden = false;
    feedSec.hidden = true;
    window.scrollTo(0, 0);
  }
  function hideKept() {
    if (!keptWrap || !feedSec) return;
    keptWrap.hidden = true;
    feedSec.hidden = false;
  }
  markKept(document);
  keptRows();

  /* ------------------------------------------------------------------ the endless wall */
  var more = document.getElementById('dv-more');
  var busy = false, watch = null, famSeen = {};
  (function () {
    var ps = feed.querySelectorAll('.dv-spike');
    for (var i = 0; i < ps.length; i++) { var f = ps[i].getAttribute('data-fam'); if (f) famSeen[f] = 1; }
  })();

  var BOARD = null, BOARDSET = null;
  function boardFilter() { return 0; }
  if (new URLSearchParams(location.search).has('board')) {
    var legacy = document.getElementById('dv-boardhead');
    if (legacy) {
      legacy.hidden = false;
      document.getElementById('dv-boardname').textContent = 'Collections have moved';
      document.getElementById('dv-boardsub').textContent = 'Browse the current collections above, or explore every design below.';
    }
  }

  function loadMore() {
    if (busy || !more || keptOpen()) return;
    var link = more.querySelector('a'), url = link && link.getAttribute('href');
    if (!url || !window.fetch || !window.DOMParser) return;
    busy = true;
    var lb = link.querySelector('.lb'), was = lb ? lb.textContent : '';
    if (lb) lb.textContent = 'Spiking…';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var batch = doc.getElementById('dv-batch');
        if (!batch) throw new Error('no batch');
        batch.removeAttribute('id');
        /* A design family can straddle the pagination boundary; Liquid's per-page dedupe
           cannot see the page before it. The other half of that family is dropped here. */
        var inc = batch.querySelectorAll('.dv-spike');
        for (var i = 0; i < inc.length; i++) {
          var f = inc[i].getAttribute('data-fam');
          if (f && famSeen[f]) { inc[i].parentNode.removeChild(inc[i]); continue; }
          if (f) famSeen[f] = 1;
        }
        var added = document.importNode(batch, true);
        feed.appendChild(added);
        markKept(added);
        boardFilter(added);
        var n = added.querySelectorAll('.dv-spike').length;
        if (status) status.textContent = n === 1 ? '1 more spike on the wall.' : n + ' more spikes on the wall.';
        var nl = doc.getElementById('dv-more'), na = nl ? nl.querySelector('a') : null;
        var nh = na ? na.getAttribute('href') : '';
        if (nh) {
          link.setAttribute('href', nh);
          if (lb) lb.textContent = was;
          busy = false;
          /* Under a board most of a page can filter away, which may leave the More link
             sitting in the viewport with no scroll ever coming. Ask again ourselves. */
          if (BOARDSET) setTimeout(function () { if (typeof sweep === 'function') sweep(); }, 60);
        }
        else {
          if (watch) watch.disconnect();
          if (more.parentNode) more.parentNode.removeChild(more);
          more = null;
          if (status) {
            status.textContent = BOARD
              ? 'That is the whole of “' + BOARD.name + '”. The rest of the wall is one step up.'
              : 'That is every joke we have made. Open any of them — the rhymes go further than the wall does.';
          }
        }
      })
      .catch(function () { busy = false; if (lb) lb.textContent = was; window.location.href = url; });
  }

  /* TWO TRIGGERS. IntersectionObserver was observed to produce no callbacks at all in a
     hidden tab (rAF does not run there either), so there is also a plain scroll check on a
     120ms timer — coarser, and always runs. It also covers a wall shorter than the screen. */
  if (more) {
    var first = more.querySelector('a');
    if (first) first.addEventListener('click', function (e) { e.preventDefault(); loadMore(); });
    if (window.IntersectionObserver) {
      watch = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) loadMore();
      }, { rootMargin: '900px 0px' });
      watch.observe(more);
    }
    var ticking = false;
    var sweep = function () {
      if (!more || keptOpen()) return;
      if (more.getBoundingClientRect().top < (window.innerHeight || 800) + 900) loadMore();
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 120);
    }, { passive: true });
    sweep();
  }

  /* ------------------------------------------------------------------ the closeup */
  var panel = document.getElementById('dv-cu-panel');
  var elImg = document.getElementById('dv-cu-img'), elT = document.getElementById('dv-cu-t');
  var elP = document.getElementById('dv-cu-p'), elBuy = document.getElementById('dv-cu-buy');
  var elRel = document.getElementById('dv-cu-rel'), elChips = document.getElementById('dv-cu-chips');
  var elFam = document.getElementById('dv-cu-fam'), elFamR = document.getElementById('dv-cu-famr');
  var elHop = document.getElementById('dv-cu-hop'), elSay = document.getElementById('dv-cu-say');
  var elSide = document.getElementById('dv-cu-side'), elSideRail = document.getElementById('dv-cu-siderail');
  var lastFocus = null, isOpen = false, current = null;

  /* HOW FAR FROM THE WALL, ANSWERED BY HISTORY ITSELF. The depth is not tracked, it is
     STORED — every entry we push carries its own distance from the wall, and popstate hands
     it straight back. It cannot drift, because nothing accumulates. */
  function stateN() { var s = history.state; return (s && typeof s.n === 'number') ? s.n : 0; }
  /* Chrome rate-limits history entries: pushState can change the URL while creating NO new
     entry. The depth is only incremented when an entry demonstrably appeared. Under-counting
     is safe (close twice); over-counting walks people off the site. */
  function pushEntry(h) {
    var before = history.length, n = stateN();
    try {
      history.pushState({ wc: h, n: n + 1 }, '', urlFor(h));
      if (history.length === before) history.replaceState({ wc: h, n: n }, '', urlFor(h));
    } catch (e) {}
  }
  function hops() { var n = stateN(); return n > 0 ? n - 1 : 0; }

  /* The stamped art URLs have their query string stripped (lib/kinship.js), so the size
     parameter has to OPEN one rather than append to one. `…png&width=420` is a CDN 404. */
  function art(u, w) { return !u ? '' : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* The chips arrive as words, not keys — lib/wall.js translates via config/jokeaxes.js at
     stamp time, so this page prints pairs it does not have to understand. */
  function chips(ch) {
    if (!ch || !ch.length) return '';
    var out = '';
    for (var i = 0; i < ch.length; i++) {
      out += '<span class="dv-chip">' + esc(ch[i][0]) + '<b>' + esc(ch[i][1]) + '</b></span>';
    }
    return out;
  }

  function tiles(items) {
    if (!items || !items.length) {
      return '<p class="dv-none">Nothing rhymes with this one yet — it is too new, or too strange. ' +
             'The wall behind you is still the best way in.</p>';
    }
    var out = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.h) continue;
      /* The intrinsic ratio comes from the metafield so the masonry never reflows. */
      var h = Math.round(400 * (it.a || 1));
      out += '<a class="dv-rp" href="/products/' + encodeURIComponent(it.h) + '" data-hop="' + esc(it.h) + '">' +
               '<span class="im">' +
                 (it.i ? '<img src="' + esc(art(it.i, 420)) + '" width="400" height="' + h +
                         '" alt="" loading="lazy" decoding="async">' : '') +
               '</span>' +
               '<span class="rt">' + esc(it.t || it.h) + '</span>' +
               (it.w ? '<span class="rw">' + esc(it.w) + '</span>' : '') +
             '</a>';
    }
    return out;
  }

  function famRow(w) {
    if (!w || !w.fam || !w.fam.length) { elFam.hidden = true; elFamR.innerHTML = ''; return; }
    var out = '';
    for (var i = 0; i < w.fam.length; i++) {
      var s = w.fam[i];
      out += '<a href="/products/' + encodeURIComponent(s.h) + '" data-hop="' + esc(s.h) + '">' +
             esc(s.ty || 'another one') + '</a>';
    }
    elFamR.innerHTML = out;
    elFam.hidden = false;
  }

  /* Draw whatever is known right now. Called twice on a hop: once immediately from the tile,
     again when the live facts land. It never prints a price it does not have.
     THE SIDE RAIL takes the first four rhymes on wide screens; the bottom feed takes the
     rest. On narrow screens the rail is display:none, so everything goes below — the split
     is decided here, not in CSS, so no rhyme is ever CSS-hidden into oblivion. */
  function paint(h) {
    var f = FACT[h] || {}, rec = IDX[h] || {};
    elImg.src = f.big || '';
    elImg.alt = '';
    elT.textContent = f.t || '';
    if (f.full) {
      elP.innerHTML = esc(f.p || '') + (f.was ? ' <span class="was">' + esc(f.was) + '</span>' : '') +
        (f.av === false ? ' <span class="out">· all gone</span>' : '');
    } else {
      elP.innerHTML = '<span class="wait">checking the live price…</span>';
    }
    elBuy.setAttribute('href', f.u || ('/products/' + encodeURIComponent(h)));
    elChips.innerHTML = chips(rec.w && rec.w.ch);
    famRow(rec.w);
    paintCuSave();
    var items = (rec.k && rec.k.items) || null;
    var wide = window.matchMedia && window.matchMedia('(min-width:1300px)').matches;
    var sideItems = (wide && items && items.length > 6) ? items.slice(0, 4) : [];
    if (sideItems.length) { elSideRail.innerHTML = tiles(sideItems); elSide.hidden = false; }
    else { elSideRail.innerHTML = ''; elSide.hidden = true; }
    var below = sideItems.length ? items.slice(4) : items;
    /* NOT-YET-KNOWN AND KNOWN-TO-BE-NONE ARE DIFFERENT STATES and the shopper is told which. */
    elRel.innerHTML = IDX[h] ? tiles(below)
      : '<p class="dv-none">Finding the ones that rhyme with it…</p>';
    var hp = hops();
    elHop.hidden = hp < 1;
    elHop.textContent = hp === 1 ? '1 hop from the wall' : hp + ' hops from the wall';
  }

  /* THE ANNOUNCEMENT WAITS FOR THE ANSWER — a screen reader was being told "no related
     designs" about designs with twelve of them, every time, before the data arrived. */
  function announce(h) {
    var t = (FACT[h] && FACT[h].t) ? FACT[h].t : 'Item';
    if (!IDX[h]) { elSay.textContent = t + ' opened. Looking for designs that rhyme with it.'; return; }
    var n = IDX[h].k && IDX[h].k.items ? IDX[h].k.items.length : 0;
    elSay.textContent = t + ' opened. ' +
      (n ? n + ' designs that rhyme with it are below.' : 'Nothing rhymes with this one yet.');
  }

  /* One request per design, ever: a second caller gets the promise the first one made. */
  function pull(h) {
    if (PEND[h]) return PEND[h];
    if (!window.fetch) return Promise.reject(new Error('no fetch'));
    PEND[h] = fetch('/products/' + encodeURIComponent(h) + '?view=kin', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        /* The tile's own facts win where they exist — they came from the same Liquid render
           as the price printed under the art. */
        if (!FACT[h] || !FACT[h].full) {
          FACT[h] = { t: j.t, u: j.u, p: j.p, was: j.was, av: j.av, big: j.big, full: true };
        }
        IDX[h] = { k: j.kin || null, w: j.wall || null };
      });
    PEND[h].catch(function () { delete PEND[h]; });
    return PEND[h];
  }

  /* Hover and first touch warm the request, so by the time the click lands the rhymes are
     usually already in hand. */
  function warm(e) {
    var t = e.target, el = t && t.closest && t.closest('.dv-spike, [data-hop]');
    if (!el) return;
    var h = el.getAttribute('data-h') || el.getAttribute('data-hop');
    if (h && !IDX[h] && !PEND[h]) pull(h).catch(function () {});
  }
  document.addEventListener('mouseover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });

  function urlFor(h) {
    var q = new URLSearchParams(location.search);
    if (h) q.set('spike', h); else q.delete('spike');
    var s = q.toString();
    return location.pathname + (s ? '?' + s : '');
  }

  function show() {
    if (isOpen) return;
    lastFocus = document.activeElement;
    cu.hidden = false;
    isOpen = true;
    document.documentElement.style.overflow = 'hidden';
    /* Focus the back control, not the surface: a dialog that opens with focus on a scroll
       container swallows the first Tab. */
    var x = cu.querySelector('.back'); if (x) x.focus();
  }

  /* THE LOAD-BEARING FUNCTION. mode 'push' adds a history entry (first open, or a hop);
     'replace' rewrites the current one (a shared link straight onto a closeup); 'pop'
     touches history not at all, because the browser has already moved it. */
  function openHandle(h, mode) {
    if (!h) return;
    current = h;
    if (mode === 'push') pushEntry(h);
    else if (mode === 'replace') { try { history.replaceState({ wc: h, n: 0 }, '', urlFor(h)); } catch (e) {} }
    paint(h);
    cu.scrollTop = 0;
    show();
    announce(h);
    if (!FACT[h] || !FACT[h].full || !IDX[h]) {
      panel.setAttribute('aria-busy', 'true');
      /* TWO HANDLERS, NOT .then().catch(): a throw inside the success path must not land in
         the failure path, which used to navigate and walked shoppers off the wall. */
      pull(h).then(function () {
        panel.removeAttribute('aria-busy');
        if (current === h && isOpen) { paint(h); announce(h); }
      }, function () {
        panel.removeAttribute('aria-busy');
        /* A failed fetch does not navigate either: the art, the title and the route to buy
           are all still on screen and still correct. */
        if (current !== h || !isOpen) return;
        elP.innerHTML = '<span class="wait">Could not reach the live price just now — it is on the item page.</span>';
        elRel.innerHTML = '<p class="dv-none">The rhymes for this one did not load. Close this and the wall is still there.</p>';
      });
    }
  }

  function closeNow() {
    if (!isOpen) return;
    isOpen = false; current = null;
    cu.hidden = true;
    elImg.src = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Closing unwinds every hop in ONE step. Back walks the chain one design at a time; the
     close control leaves it. n came off the entry we are standing on, so it is exactly the
     number of entries this page pushed — never more. */
  function dismiss() {
    if (!isOpen) return;
    var n = stateN();
    closeNow();
    if (n > 0) { try { history.go(-n); return; } catch (e) {} }
    try { history.replaceState({}, '', urlFor(null)); } catch (e) {}
  }

  /* ONE DELEGATED LISTENER for the whole page, so appended pages, the saved wall and the
     tiles the closeup draws into itself are all live without rebinding anything. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var keep = t.closest('[data-keep]');
    if (keep) { e.preventDefault(); toggleKeep(keep.getAttribute('data-keep')); return; }
    var keepcu = t.closest('[data-keepcu]');
    if (keepcu && isOpen) { e.preventDefault(); toggleKeep(current); return; }
    var kv = t.closest('[data-keptview]');
    if (kv) { e.preventDefault(); showKept(); return; }
    if (t.closest('[data-keptback]')) { e.preventDefault(); hideKept(); return; }
    var sh = t.closest('[data-sharetile]');
    if (sh) {
      e.preventDefault();
      var hh0 = sh.getAttribute('data-sharetile');
      var link0 = location.origin + location.pathname + '?spike=' + encodeURIComponent(hh0);
      if (navigator.share) { navigator.share({ url: link0 }).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(link0).then(function () {
          if (status) status.textContent = 'Link copied.';
        }, function () {});
      }
      return;
    }
    if (isOpen && t.closest('[data-sharecu]')) {
      e.preventDefault();
      var linkC = location.origin + urlFor(current);
      if (navigator.share) { navigator.share({ url: linkC }).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(linkC).then(function () {
          elSay.textContent = 'Link copied.';
        }, function () {});
      }
      return;
    }
    if (isOpen && t.closest('[data-close]')) { e.preventDefault(); dismiss(); return; }
    if (isOpen && t.closest('[data-copy]')) {
      e.preventDefault();
      var btn = t.closest('[data-copy]'), full = location.origin + urlFor(current);
      var done = function () {
        btn.classList.add('ok');
        elSay.textContent = 'Link copied.';
        setTimeout(function () { btn.classList.remove('ok'); }, 1800);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(full).then(done, done); else done();
      return;
    }
    /* THE DOORWAY: a rhyme tile or a sibling chip inside the closeup. Real links, so
       modified clicks, middle clicks and scripting-off keep doing the ordinary thing. */
    var hop = t.closest('[data-hop]');
    if (hop && isOpen) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      var hh = hop.getAttribute('data-hop');
      /* Seed what the tile already knows, so the closeup repaints instantly and the live
         price catches up a moment later. */
      if (!FACT[hh]) {
        var img = hop.querySelector('img'), ttl = hop.querySelector('.rt');
        FACT[hh] = { t: ttl ? ttl.textContent : '', big: img ? img.getAttribute('src') : '', full: false };
      }
      openHandle(hh, 'push');
      return;
    }
    var tile = t.closest('.dv-spike');
    if (!tile || !tile.closest('#dv-feed, #dv-kept')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    /* The hover circle is the deliberate escape hatch straight to the item page. */
    if (t.closest('a.ovc')) return;
    e.preventDefault();
    var ph = tile.getAttribute('data-h');
    if (!FACT[ph] || !FACT[ph].full) FACT[ph] = factsFromTile(tile);
    openHandle(ph, 'push');
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); dismiss(); return; }
    if (e.key !== 'Tab') return;
    /* Focus trap over the whole closeup surface — the side rail included, or its first four
       rhymes would be mouse-only. */
    var f = cu.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* THE URL IS THE SOURCE OF TRUTH for what is open — that is what makes Back walk the chain
     of hops, and a pasted link land on a closeup instead of the top of the wall. */
  window.addEventListener('popstate', function () {
    var h = new URLSearchParams(location.search).get('spike');
    if (h) openHandle(h, 'pop'); else closeNow();
  });

  /* A SHARED CLOSEUP: /pages/discover?spike=<handle>. REPLACE rather than push, so Back
     leaves the page the way leaving any page does. Scripting off: the same URL is the wall. */
  (function () {
    var h = new URLSearchParams(location.search).get('spike');
    if (!h) return;
    var tile = feed.querySelector('.dv-spike[data-h="' + h.replace(/["\\]/g, '') + '"]');
    if (tile) FACT[h] = factsFromTile(tile);
    openHandle(h, 'replace');
  })();

  /* ------------------------------------------------------------------ the pill's two tools
     Only shown because this script is running (.wcjs) — and the mic only where dictation is
     genuinely supported. The camera slot opens a spike at random: an honest job for the
     "show me something" position on a page whose premise is that you had no query. */
  var cam = document.getElementById('pv-cam');
  if (cam) {
    cam.hidden = false;
    cam.addEventListener('click', function () {
      var ts = feed.querySelectorAll('.dv-spike');
      if (!ts.length) return;
      var tile = ts[Math.floor(Math.random() * ts.length)];
      var h = tile.getAttribute('data-h');
      if (!FACT[h] || !FACT[h].full) FACT[h] = factsFromTile(tile);
      openHandle(h, 'push');
    });
  }
  (function () {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    var b = document.getElementById('pv-mic'), inp = document.getElementById('dv-q');
    if (!b || !inp) return;
    if (!SR) { b.hidden = true; return; }
    b.hidden = false;
    b.addEventListener('click', function () {
      try {
        var r = new SR();
        r.lang = document.documentElement.lang || 'en';
        b.classList.add('rec');
        r.onresult = function (ev) {
          b.classList.remove('rec');
          var s = ev.results && ev.results[0] && ev.results[0][0] ? ev.results[0][0].transcript : '';
          if (s) { inp.value = s; if (inp.form) inp.form.submit(); }
        };
        r.onerror = function () { b.classList.remove('rec'); };
        r.onend = function () { b.classList.remove('rec'); };
        r.start();
      } catch (err) { b.classList.remove('rec'); }
    });
  })();
})();
